import React from 'react'
import { useTranslation } from "react-i18next";
import { DirectionalHint, TooltipHost } from '@fluentui/react';
import { enum__MessageStatus } from '../../../../common/Dictionaries';

function MessageIconStatus(props) {
    const { t } = useTranslation();


    //Parametros de entrada.
    const inputParam_StatusId = props.statusId !== null && props.statusId !== undefined ? props.statusId : null;
    const inputParam_Visa = props.visa !== null && props.visa !== undefined ? props.visa : null;
    const inputParam_AcceptSendedStatus = props.acceptSendedStatus !== null && props.acceptSendedStatus !== undefined ? props.acceptSendedStatus : false;
    const inputParam_Style = props.style !== null && props.style !== undefined ? props.style : null;
    
    const messageStatusStyles2 = inputParam_Style !== null ? inputParam_Style : {"right": "28px", "position": "absolute", "top": "20px", "fontSize": "20px"}
    const messageStatusStyles = inputParam_Style !== null ? inputParam_Style : {"right": "5px", "position": "absolute", "top": "20px", "fontSize": "20px"}

    //Render de componente.
    return (
        <>
            {
                inputParam_StatusId === 1 ? 
                //[##CODELCO-CARD-##] Borradores Book
                //Resaltar mensaje en borrador
                <div style={messageStatusStyles}><TooltipHost content={t(`data-lang-sbmessage-status${inputParam_StatusId}`)} directionalHint={DirectionalHint.bottomAutoEdge}><i className="ms-Icon ms-Icon--MailOptions font-weight-bold" style={{color: '#ca4242'}} aria-hidden="true"></i></TooltipHost></div>: <></>
            }
            {
                inputParam_StatusId === 2 ? 
                <div style={messageStatusStyles}><TooltipHost content={t(`data-lang-sbmessage-status${inputParam_StatusId}`)} directionalHint={DirectionalHint.bottomAutoEdge}><i className="ms-Icon ms-Icon--ArrangeByFrom" aria-hidden="true"></i></TooltipHost></div>: <></>
            }
            {
                inputParam_StatusId === 3 ? 
                <div style={messageStatusStyles}><TooltipHost content={t(`data-lang-sbmessage-status${inputParam_StatusId}`)} directionalHint={DirectionalHint.bottomAutoEdge}><i className="ms-Icon ms-Icon--MailAlert" aria-hidden="true"></i></TooltipHost></div>: <></>
            } 
            {
                inputParam_AcceptSendedStatus && inputParam_StatusId === 4 ? 
                <div style={messageStatusStyles}><TooltipHost content={t(`data-lang-sbmessage-status${inputParam_StatusId}`)} directionalHint={DirectionalHint.bottomAutoEdge}><i className="ms-Icon ms-Icon--MailForward" aria-hidden="true"></i></TooltipHost></div>: <></>
            } 
            {
                (inputParam_StatusId === enum__MessageStatus.TOVISA) ?
                <>
                    <div style={messageStatusStyles2}><TooltipHost content={t(`data-lang-sbmessage-status1`)} directionalHint={DirectionalHint.bottomAutoEdge}><i className="ms-Icon ms-Icon--MailOptions font-weight-bold" style={{color: '#ca4242'}} aria-hidden="true"></i></TooltipHost></div>
                    {
                        inputParam_Visa !== 1 &&inputParam_Visa !== 2 &&
                        <div style={messageStatusStyles}><TooltipHost content={t(`data-lang-sbmessage-status${inputParam_StatusId}`)} directionalHint={DirectionalHint.bottomAutoEdge}><i className="ms-Icon ms-Icon--MailCheck" style={{color: '#ca9442'}} aria-hidden="true"></i></TooltipHost></div>
                    }
                    {
                        inputParam_Visa === 2 &&
                        <div style={messageStatusStyles}><TooltipHost content={t(`data-lang-lbl-visarejected`)} directionalHint={DirectionalHint.bottomAutoEdge}><i className="ms-Icon ms-Icon--StatusErrorFull" style={{color: '#ca9442'}} aria-hidden="true"></i></TooltipHost></div>
                    }
                    {
                        inputParam_Visa === 1 &&
                        <div style={messageStatusStyles}><TooltipHost content={t(`data-lang-lbl-visaaproved`)} directionalHint={DirectionalHint.bottomAutoEdge}><i className="ms-Icon ms-Icon--SkypeCircleCheck" style={{color: '#ca9442'}} aria-hidden="true"></i></TooltipHost></div>
                    }
                </>: <></>
            } 
        </>
    );
}

export default MessageIconStatus;